export default "__VITE_ASSET__BERmW9cB__"